import script from "./SolutionsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionsSection.vue?vue&type=script&setup=true&lang=js"

import "./SolutionsSection.vue?vue&type=style&index=0&id=7a6f7d0b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a6f7d0b"]])

export default __exports__